import {useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import Product from '../Product/Product';
import styles from './ProductList.module.css'
import { ProductBasedRules } from "../../Helpers/ProductBasedRules";


export default function ProductList({seriesId, thumbSize, handleSelect, selectedProductId, filters, initialProductLimit = 25, incrementAtScroll = 25, className ="", key="A", addNoneOption=false, doesNotVizualize=false, noneOptionTitle=""}) {
    

    const productRules = {
        "Traditional": {
            "All": {
                "Standard": "L1",
                "Upgrade": "L2"
            },
            "Matanzas Cove": {
                "Standard": "L3",
                "Exclude": "L4"
            }
        },
        "Signature": {
            "All": {
                "Standard": "L5",
                "Upgrade": "L6"
            },
            "Beachview": {
                "Standard": "L7",
                "Exclude": "L8"
            }
        }
    };

    const [productData, setproductData] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(-1);
    const activeScene = useSelector((state) => state.visualizer.specifier);
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    const activeFloorPlanData = useSelector((state) => state.visualizer.activeFloorPlanData);
    const activeCommunity = useSelector((state) => state.visualizer.activeCommunity);

    let standardCodeDisplay = "na"

    const { filterProduct, getTierString } = ProductBasedRules();

    

    const [productCounter, setProductCounter] = useState(initialProductLimit);
    const handleProductSelect = function(id) {
        var productObj = productData.filter(p => p.id === id);
        handleSelect(productObj[0]);
        setSelectedProduct(id);
    }

    //Infinite Scrolling - Partially loads products and loads more as user scroll
    const handleScroll = (event) => {
        let scrollBottom = Math.abs(event.target.scrollHeight - event.target.clientHeight - event.target.scrollTop);
        if(scrollBottom < 250){
            setProductCounter(currentCounter => {
                return currentCounter+=incrementAtScroll;
            })
        }
    }


    
    // Fetch and filter data from the product series
    useEffect(() => {
        const URL = `https://lizard.chameleonpower.com/CDN/ProductsBySeries/${seriesId}.json`;
        fetch(URL)
            .then((response) => response.json())
            .then((data) => {

                
                // Filter data by scene name if necessary
                const dataFilteredByScene = data.filter(prod => {
                    if (prod.descriptor.includes('\\')) {
                        let sceneName = activeScene;
                        return prod.descriptor.toLowerCase() === sceneName.toLowerCase();
                    }
                    return true;
                });


                // Filter by trad vs signature
                var seriesStandardCode = productRules[activeFloorPlanData.series]["All"]["Standard"];
                var seriesUpgradeCode = productRules[activeFloorPlanData.series]["All"]["Upgrade"];

                var excpeptionStandard = "na";

                if(productRules[activeFloorPlanData.series][activeCommunity] !== undefined){
                    seriesStandardCode = productRules[activeFloorPlanData.series][activeCommunity]["Standard"];
                }


                let dataFilteredBySeries = dataFilteredByScene;

                const threeDseries = [8529,8528,8548,8531,8533,8602,8532,8534,8530,8527,8489,8549];

                if(!threeDseries.includes(seriesId)){
                     dataFilteredBySeries = dataFilteredByScene.filter(prod => {
                            
                        if(prod.style.indexOf(seriesStandardCode) === -1 && prod.style.indexOf(seriesUpgradeCode) === -1 && prod.style.indexOf(excpeptionStandard) === -1){
                            return false;
                        }
                        else return true;

                    });  
                }
             

                //other filtering
                let dataFilteredByExcludes = dataFilteredBySeries;

                let excludeCode = "na"
                if(productRules[activeFloorPlanData.series][activeCommunity] !== undefined) excludeCode = productRules[activeFloorPlanData.series][activeCommunity]["Exclude"];

                    dataFilteredByExcludes = dataFilteredBySeries.filter(prod => {
                        
                        if(prod.style.indexOf(excludeCode) !== -1){
                            return false;
                        }
                        else return true;

                    });

                // if(productRules[activeFloorPlanData.series][activeCommunity] !== undefined){
                //     debugger;
                //     const excludeCode = productRules[activeFloorPlanData.series][activeCommunity]["Exclude"];

                //     dataFilteredByExcludes = dataFilteredByScene.filter(prod => {
                //         // if(prod.style.indexOf(excludeCode) !== -1){
                //         //     return false;
                //         // }
                        
                //         // if(prod.style.indexOf(seriesStandardCode) === -1 && prod.style.indexOf(seriesUpgradeCode) === -1){
                //         //     return false;
                //         // }
                //         // else return true;

                //         return false;
                //     });
                // }


                let sortedData = dataFilteredByExcludes;

                let standardCode = productRules[activeFloorPlanData.series]["All"]["Standard"];
                if(productRules[activeFloorPlanData.series][activeCommunity] !== undefined){
                    standardCode = productRules[activeFloorPlanData.series][activeCommunity]["Standard"];
                }

                console.log("Standard Code >>>> "+standardCode);
                
                const standardProducts = [];
                const upgradeProducts = [];
                
                sortedData.forEach(product => {
                    if(product.style.includes(standardCode)){
                        standardProducts.push({ ...product, tier: "Standard" });
                    }else{
                        upgradeProducts.push({ ...product, tier: "Upgrade" });
                    }
                });

                //const sortedUpgradedProducts = 
                upgradeProducts.sort((a,b) => a[activeStep.sortBy].localeCompare(b[activeStep.sortBy]));
                standardProducts.sort((a,b) => a[activeStep.sortBy].localeCompare(b[activeStep.sortBy]));


                sortedData = standardProducts.concat(upgradeProducts);
                
                
                if(addNoneOption){
                    sortedData.unshift({
                        lightness: 0,
                        b: 0,
                        g: 0,
                        r: 0,
                        seriesID: -1,
                        id: -1,
                        sortOrder: 0,
                        categoryID: 202,
                        manufacturerID: 35,
                        colorHEX: null,
                        seriesName: "",
                        categoryName: "",
                        manufacturerName: "Chameleon Power",
                        manufacturerSeriesName: "",
                        genericDisplayName: "",
                        displayName: "",
                        efficiency: "",
                        ecoFriendly: "",
                        style: "",
                        thumbnailRenderOptions: "",
                        defaultRoomSceneSpecifier: "",
                        warranty: "",
                        productURL: "",
                        descriptor: "None",
                        description: "None",
                        specifier: "-1",
                        sku: "",
                        color: "None",
                        name: noneOptionTitle
                        });
                }
                if (filters !== "na") {
                    setproductData(sortedData.filter(prod => prod.id === -1 || eval(filters)));
                } else {
                    setproductData(sortedData);
                }
            });
        if (selectedProductId) setSelectedProduct(selectedProductId);
    }, [seriesId, selectedProductId, filters, activeScene]);

    // Generate the product items list
    let productItems = productData.map((product, index) => {
        if(index < productCounter || 1 == 1){
            return <Product 
            key={product.id}
            id={product.id} 
            product={product}
            tierColumn={activeStep.tier}
            specifier={product.specifier} 
            warranty={product.warranty}
            tier={product.tier}
            focus={500}
            size={thumbSize} 
            title={product.name} 
            description={product.color !== ""?product.color:product.sku} 
            series = {seriesId}
            onSelect={handleProductSelect}
            isActive={product.id == selectedProduct?true:false}/>
        }
        else return null;
    })

    return(
        <>
            {doesNotVizualize && (
                <div className={styles.disclaimer}>
                    <small className={styles.subTitle}>These products are not visually rendered in the scene but are saved for reference.</small>
                </div>
            )}
            <div className={styles.productListDiv}> 
                <ul className={styles.productList +" "+ className} data-series={seriesId} onScroll={handleScroll}>
                    {productItems}
                </ul>
                {/* <span>Active Community - {activeCommunity}</span> */}
            </div>
        </>
    );
}